import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CommunityStakeholdersInvolvementAndParticipationAnecdotes = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Community stakeholders' involvement and participation anecdotes" />
    </Box>
  );
};
